import { ErrorMessage } from 'formik';
import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import useFieldDecorators from '../hooks/useFieldDecorators';
import './FileField.css';
import Tooltip from '../common/Tooltip';
const FileField = (props) => {
    const { isRequired, helpBlock, contentCssClass, labelCssClass } = useFieldDecorators(props);
    const [file, setFile] = useState(props.existingFile
        ? Object.assign(props.existingFile, {
            preview: URL.createObjectURL(props.existingFile),
        })
        : null);
    const { getRootProps, getInputProps } = useDropzone(Object.assign({ accept: props.acceptTypes, noDrag: true, multiple: false, onDrop: (acceptedFiles) => {
            if (acceptedFiles[0]) {
                setFile(Object.assign(acceptedFiles[0], {
                    preview: URL.createObjectURL(acceptedFiles[0]),
                }));
                props.onChange(acceptedFiles[0]);
            }
        } }, (props.dropZoneOptions ? props.dropZoneOptions : {})));
    return (React.createElement("div", { className: "form-group row" },
        React.createElement("label", { htmlFor: props.name, className: `${labelCssClass} control-label` },
            isRequired,
            props.label,
            " \u00A0",
            React.createElement(Tooltip, { text: props.tooltip, name: props.name })),
        React.createElement("div", { className: contentCssClass },
            React.createElement("div", Object.assign({}, getRootProps({ className: 'dropzone pointer' })),
                React.createElement("input", Object.assign({ id: props.name, "data-testid": props.testId }, getInputProps())),
                React.createElement("p", null, props.dropZoneText)),
            React.createElement(ErrorMessage, { name: props.name, className: "text-danger", component: "small" }),
            helpBlock,
            props.hideThumbnail ? null : React.createElement(Thumbnail, { file: file }))));
};
const Thumbnail = ({ file }) => {
    let newThumbnail = null;
    if (file) {
        // Show thumbnail by default if the file MIME type begins with image/
        if (file.type.startsWith('image/')) {
            newThumbnail = (React.createElement("div", { className: "thumbnail" },
                React.createElement("img", { src: file.preview, alt: file.preview, "data-testid": "preview-image", className: "img-fluid" })));
        }
        else {
            newThumbnail = (React.createElement("div", { className: "thumbnail" },
                React.createElement("span", { "data-testid": "preview-filename" }, file.name)));
        }
    }
    return newThumbnail;
};
export default FileField;
